import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "warning-span flex align-content-center justify-content-center p-3"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: { "color": "var(--purple-500)", "font-size": "2rem", "margin-right": "10px" }
}, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h5", null, "No market selected", -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
import { onBeforeMount, ref, watch } from "vue";
import OneDeskTable from "@/components/organisms/OneDeskTable.vue";
import { getAllMarketsPaginated as getAllMarketsPaginated } from "@/repositories/market.repository";
import { FilterMatchMode } from "primevue/api";
import { marketColumns as marketColumns } from "@/shared/utils/columns-definition/market";
import AppConfigSideBar from "@/components/templates/Layout/AppConfigSideBar.vue";
import Button from "primevue/button";
import UpdateMarket from "@/components/templates/BackOffice/forms/inventory/UpdateMarket.vue";
import OneDeskMarketColumn from "@/components/molecules/OneDeskMarketColumn.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackOfficeMarkets',
    setup(__props) {
        const globalFilterFields = ref(["displayMarket"]);
        const columnsDefinition = ref(marketColumns);
        const markets = ref([]);
        const openAppConfig = ref(false);
        const selectedMarket = ref();
        const pageNumber = ref(1);
        const pageSize = ref(10);
        const search = ref("");
        const totalRecords = ref(0);
        const totalPages = ref(0);
        const loading = ref(false);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const onEditClick = (data) => {
            selectedMarket.value = data;
            openAppConfig.value = true;
        };
        onBeforeMount(async () => {
            await retrieveMarkets();
        });
        const onMarketUpdated = () => {
            selectedMarket.value = undefined;
            openAppConfig.value = false;
            retrieveMarkets();
        };
        const onSearchChange = (searchText) => {
            pageNumber.value = 1;
            search.value = searchText;
        };
        watch([pageNumber, pageSize, search], () => {
            retrieveMarkets();
        });
        const retrieveMarkets = async () => {
            loading.value = true;
            const paginatedListOfMarkets = await getAllMarketsPaginated(pageNumber.value, pageSize.value, search.value);
            markets.value = paginatedListOfMarkets.items;
            totalRecords.value = paginatedListOfMarkets.totalCount;
            totalPages.value = paginatedListOfMarkets.totalPages;
            loading.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppConfigSideBar, {
                    simple: "",
                    title: "Manage markets",
                    active: selectedMarket.value !== undefined,
                    modelValue: openAppConfig.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((openAppConfig).value = $event))
                }, {
                    default: _withCtx(() => [
                        (selectedMarket.value)
                            ? (_openBlock(), _createBlock(UpdateMarket, {
                                key: 0,
                                modelValue: selectedMarket.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedMarket).value = $event)),
                                onMarketUpdated: onMarketUpdated
                            }, null, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                    ]),
                    _: 1
                }, 8, ["active", "modelValue"]),
                _createVNode(OneDeskTable, {
                    title: "Markets",
                    "columns-definition": columnsDefinition.value,
                    tableData: markets.value,
                    class: _normalizeClass('user_table'),
                    hasPagination: true,
                    filters: filters.value,
                    globalFilterFields: globalFilterFields.value,
                    countLabel: { plural: 'markets', singular: 'market' },
                    totalRecords: totalRecords.value,
                    "page-index": pageNumber.value,
                    "page-size": pageSize.value,
                    onPageChange: _cache[2] || (_cache[2] = ($event) => (pageNumber.value = $event + 1)),
                    loading: loading.value,
                    onSearchChange: _cache[3] || (_cache[3] = ($event) => (onSearchChange($event))),
                    "on-row-click": ($event) => onEditClick($event)
                }, {
                    market: _withCtx((slotProps) => [
                        _createVNode(OneDeskMarketColumn, {
                            "market-code": slotProps.item.id
                        }, null, 8, ["market-code"])
                    ]),
                    actions: _withCtx((slotProps) => [
                        _createVNode(_unref(Button), {
                            onClick: ($event) => (onEditClick(slotProps.item)),
                            size: "small",
                            icon: "pi pi-pencil",
                            label: "Edit"
                        }, null, 8, ["onClick"])
                    ]),
                    _: 1
                }, 8, ["columns-definition", "tableData", "filters", "globalFilterFields", "totalRecords", "page-index", "page-size", "loading", "on-row-click"])
            ], 64));
        };
    }
});
